import styled from "styled-components";

import { colors } from "../../../../../consts";
import { Paragraph2, SmallButtonStyled, WrapperContainer } from "../../../../../components";
import { ButtonsPopupStyled } from "../../../../../components/ButtonsPopup/styled";
import { IconButtonStyled } from "../../../../../components/Buttons/styled";

export const MarketItemStyled = styled(WrapperContainer)`
  height: 126px;
  width: 100%;
  max-width: 430px;

  border-radius: 16px;
  border: 1px solid;
  border-color: ${colors.RAISIN_10};

  padding: 16px;

  > ${Paragraph2} {
    font-weight: 700;
    font-size: 20px;
  }
`;

export const ButtonsWrapper = styled(WrapperContainer)`
  ${SmallButtonStyled} {
    height: 40px;
    padding: 0 16px;
    gap: 8px !important;
  }

  ${IconButtonStyled}, ${SmallButtonStyled} {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 4px;
  }
`;

export const ButtonsPopupContainer = styled(WrapperContainer)`
  ${ButtonsPopupStyled} {
    top: 4px;
    width: 130px;
    margin-left: 0;
    right: -24px;
  }
`;
